import {LocaleData} from '@sail/intl';
import {LocaleBCP47} from 'mkt-ssr/lib/globalization/types';

const LocaleDataLoaders: {
  [K in LocaleBCP47]: () => Promise<{locale: LocaleData}>;
} = {
  'en-US': async () => import('./localeData/enUS'),
  'es-419': async () => import('./localeData/es419'),
  'zh-Hans': async () => import('./localeData/zhHans'),
  'de-DE': async () => import('./localeData/deDE'),
  'en-GB': async () => import('./localeData/enGB'),
  'nl-NL': async () => import('./localeData/nlNL'),
  'fr-FR': async () => import('./localeData/frFR'),
  'pt-BR': async () => import('./localeData/ptBR'),
  'fr-CA': async () => import('./localeData/frCA'),
  'it-IT': async () => import('./localeData/itIT'),
  'es-ES': async () => import('./localeData/esES'),
  'sv-SE': async () => import('./localeData/svSE'),
  'ja-JP': async () => import('./localeData/jaJP'),
  'th-TH': async () => import('./localeData/thTH'),
};

// NB: This type overlaps with the original one sufficiently to
// leave it mapped this way, but we give it a rename here to
// make it clear to readers that this type *does* modify
// the source data in a meaningful way.
export type LocaleDataWithoutTimezones = LocaleData;

export async function getDataForLocale(
  bcp47: LocaleBCP47,
): Promise<{locale: LocaleDataWithoutTimezones}> {
  const result = await LocaleDataLoaders[bcp47]();

  // NB: This chunk of data is *huge* (~30kb for en-us), and
  // there is nowhere that we are utilizing this on our pages,
  // and are unlikely to do so anytime in the near future, as such
  // we strip it out of this data in order to reduce our overall response
  // size by nearly half.
  if (result.locale.cldr) {
    result.locale.cldr.cldrTimeZoneNames = {};
  }
  return result;
}
